export enum CreateOnsiteInterviewSteps {
  Reviews = 'reviews',
  WorkDetails = 'work-details',
}

export type TCreateOnsiteInterviewPageRoutes = { id: string };

export type TCreateOnsiteInterviewPageLocationState = {
  isAfterJobPosting?: boolean;
};
